import { __extends } from "tslib";
import React from 'react';
import Comments from '../svgs/components/comments';
var CommentButton = /** @class */ (function (_super) {
    __extends(CommentButton, _super);
    function CommentButton(props) {
        var _this = _super.call(this, props) || this;
        _this.getMobileEnabledClick = _this.getMobileEnabledClick.bind(_this);
        _this.getCommentsCounter = _this.getCommentsCounter.bind(_this);
        return _this;
    }
    CommentButton.prototype.getMobileEnabledClick = function (action) {
        return this.props.isMobile ? { onTouchEnd: action } : { onClick: action };
    };
    CommentButton.prototype.getCommentsCounter = function () {
        return this.props.commentsCounter;
    };
    CommentButton.prototype.render = function () {
        var commentsCounter = this.getCommentsCounter();
        return commentsCounter ? (React.createElement("span", { className: 'info-member info-element-social-comments info-element-social-button', "data-hook": "comments-button", tabIndex: -1, role: "checkbox", "aria-checked": this.props.isLoved, "aria-label": 'Comments' },
            React.createElement(Comments, { className: "info-element-social-comments-icon" }),
            React.createElement("div", { className: "info-element-social-comments-count" }, commentsCounter))) : React.createElement("div", null);
    };
    return CommentButton;
}(React.Component));
export default CommentButton;
//# sourceMappingURL=CommentsButton.js.map